import * as sentryReporter from "@/services/sentryReporter.js"

export default {
  install(app) {
    app.config.globalProperties.$reportError = function (err, snackbarError) {
      sentryReporter.reportError(err, snackbarError)
    }

    app.config.globalProperties.$reportMessage = function (message, tag) {
      sentryReporter.reportMessage(message, tag)
    }
  }
}
